import * as moment_ from 'moment';

const moment = moment_;

export class FiltrosDiarioOffLine {
    public FiltrarByFechasOff(Data, AddToDoc: Function) {
        try {
            var rows: Array<any>;
            //var newRows = new Array<any>();
            var fechaI = sessionStorage.getItem("FechaItCOFF");
            var fechaF = sessionStorage.getItem("FechaFtCOFF");
            rows = Data.rows;

            if (fechaF && fechaI) {
                var iFInicio = this.GetFechaNumber(fechaI);
                var iFFinal = this.GetFechaNumber(fechaF);
                console.log(iFInicio)
                console.log(iFFinal)
                for (var i = 0; i < rows.length; i++) {
                    var m3p: any = rows[i].doc;
                    if (m3p) {
                        var fechaProc = this.GetFechaNumber(m3p.Fecha)
                        console.log(fechaProc)
                        if (+fechaProc >= +iFInicio && +fechaProc <= +iFFinal) {
                            //newRows.push(rows[i]);
                            AddToDoc(m3p);
                        }
                    }
                }
            }

        } catch (ex) {
            console.log("FiltrarByFechasOff")
            console.log(ex)
        }


    }


    public FiltrarByTexto(Data, sTexto: string, AddToDoc: Function) {
        try {
            var rows: Array<any>;

            rows = Data.rows;
            for (var i = 0; i < rows.length; i++) {
                var m3p: any = rows[i].doc;
                if (m3p) {
                    if (m3p.IdM3.includes(sTexto) || (m3p.ndocUActivo && m3p.ndocUActivo.includes(sTexto))) {
                        //newRows.push(rows[i]);
                        AddToDoc(m3p);
                    }
                }
            }

        } catch (ex) {
            console.log("FiltrarByFechasOff")
            console.log(ex)
        }


    }


    private GetFechaNumber(sdate: string) {
        //var date = new Date(sdate);
        var d = moment(sdate).format('YYYYMMDD');

        return d;
    }
}